/** Normalize Indian vehicle registration to uppercase without spaces. */
export function normalizeIndianRegistration(value) {
  return String(value || '')
    .toUpperCase()
    .replace(/\s+/g, '')
    .replace(/-/g, '')
    .trim();
}

/** Format for display: XX-00-XX-0000 */
export function formatIndianRegistration(value) {
  const raw = normalizeIndianRegistration(value);
  const m = raw.match(/^([A-Z]{2})(\d{1,2})([A-Z]{1,3})(\d{4})$/);
  if (!m) return value?.toUpperCase() || '';
  return `${m[1]}-${m[2]}-${m[3]}-${m[4]}`;
}

export function isValidIndianRegistration(value) {
  const raw = normalizeIndianRegistration(value);
  return /^[A-Z]{2}\d{1,2}[A-Z]{1,3}\d{4}$/.test(raw);
}

export const DAMAGE_TYPE_OPTIONS = [
  { value: 'front_damage', label: 'Front damage' },
  { value: 'rear_damage', label: 'Rear damage' },
  { value: 'side_damage', label: 'Side damage' },
  { value: 'flood', label: 'Flood' },
  { value: 'fire', label: 'Fire' },
  { value: 'engine_failure', label: 'Engine failure' },
  { value: 'other', label: 'Other' },
];

export const SOURCE_TYPE_OPTIONS = [
  { value: 'purchased_scrap', label: 'Purchased scrap' },
  { value: 'insurance_salvage', label: 'Insurance salvage' },
  { value: 'repossession', label: 'Repossession' },
  { value: 'trade_in', label: 'Trade-in' },
  { value: 'other', label: 'Other' },
];

export const FUEL_TYPE_OPTIONS = ['Petrol', 'Diesel', 'CNG', 'LPG', 'Electric', 'Hybrid'];

export const TRANSMISSION_OPTIONS = ['Manual', 'Automatic', 'AMT', 'CVT', 'DCT'];
